// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".order-details-page .page-content{background:var(--main-bg-color)}.cancel-button{margin:1rem 0 !important}.fa-custom{font-size:1.25em;margin-left:2px;margin-right:6px !important}.stripe-resume-button-container{padding:.5rem 1rem}.note{overflow-wrap:break-word}\n", ""]);
// Exports
module.exports = exports;
